export const evaluationItems: {
  title: string
  imgPath: string
  url: string
  profile: {
    date: string
    content: JSX.Element
  }[]
}[] = [
  {
    title: 'Ministry of Health, Labour and Welfare',
    imgPath: '/images/ir-approval.png',
    url: 'https://jsite.mhlw.go.jp/fukuoka-roudoukyoku/content/contents/000393811.pdf',
    profile: [
      {
        date: 'Eruboshi (3 stars)',
        content: (
          <>
            Under Japan’s Act on Promotion of Women’s Participation and Advancement in the Workplace, the Ministry of Health, Labour and Welfare has established the “Eruboshi Certification” to recognize companies that demonstrate excellence in promoting gender equality. Based on criteria such as recruitment, career development, work-life balance, and workplace environment, the certification is awarded in three levels. We have been awarded the highest level—three stars—reflecting our strong commitment to advancing women in the workplace.
          </>
        )
      },
    ],
  },
  {
    title: 'Ministry of Health, Labour and Welfare',
    imgPath: '/images/ir-certification.jpg',
    url: 'https://jsite.mhlw.go.jp/fukuoka-roudoukyoku/content/contents/001294466.pdf',
    profile: [
      {
        date: 'MONISU Certification System',
        content: (
          <>
            TRIAL Benefit, Inc. obtained certification under the Ministry of Health, Labour and Welfare’s MONISU Certification System for small and medium-sized enterprises excelling in the employment of persons with disabilities. The certification is to recognize small and medium-sized enterprises (SMEs)  for excellence in promoting and stabilizing the employment of persons with disabilities, aiming to advance such efforts across the SMEs sector nationwide.
          </>
        )
      },
    ],
  },
  {
    title: 'Nikko Investor Relations Co., Ltd.',
    imgPath: '/images/ir-winning-en.png',
    url: 'https://pdf.irpocket.com/C141A/PDLX/SrrF/xqcF.pdf',
    profile: [
      {
        date: 'All Japanese Listed Companies\' Website Ranking in 2025',
        content: (
          <>
            Nikko Investor Relations Co., Ltd. evaluated the websites of all 3,937 listed companies based on three perspectives: “Clarity,” “Usability,” and “Informativity,” deviation scores were calculated for each criterion, and published the results as a ranking.
            <br />
            In the Growth Market category, the top 10 companies were awarded as “With Grade AAA Corporate Websites,” and 26 companies as “With Grade AA Corporate Websites”. TRIAL Holdings, Inc. received “With Grade AAA Corporate Websites” for the second time and for the second consecutive year.
          </>
        )
      },
    ],
  },
  {
    title: 'The Securities Analysts Association of Japan (SAAJ)',
    imgPath: '/images/ir-winning-en-2025.jpg',
    url: 'https://pdf.irpocket.com/C141A/w4ok/y4Wp/moNP.pdf',
    profile: [
      {
        date: '2025 Award for Excellence in Corporate Disclosure in the Emerging Markets Category',
        content: (
          <>
            This award has been conducted by SAAJ since 1995 with the aim of promoting and improving corporate disclosures.
            <br />
            TRIAL Holdings, Inc. received “2025 Award for Excellence in Corporate Disclosure” for the first time in the Emerging Markets category by the Securities Analysts Association of Japan (SAAJ).
          </>
        )
      },
    ],
  },
]
